const routers = [
	{
		path: '/',
    meta: {layout: 'default'},
		component: (resolve) => require(['./pages/workbench.vue'], resolve).default
	},
  {
    name: 'login',
    path: '/login',
    meta: {layout: 'plain'},
    component: (resolve) => require(['./pages/login.vue'], resolve)
  },
	{
		name: 'vendor',
		path: '/vendor',
    meta: {layout: 'default'},
		component: (resolve) => require(['./pages/vendor.vue'], resolve)
	},
  {
    name: 'device',
    path: '/device',
    meta: {layout: 'default'},
    component: (resolve) => require(['./pages/device.vue'], resolve)
  },
  {
    name: 'brand',
    path: '/brand',
    meta: {layout: 'default'},
    component: (resolve) => require(['./pages/brand.vue'], resolve)
  },
  {
    name: 'feedback',
    path: '/feedback',
    meta: {layout: 'default'},
    component: (resolve) => require(['./pages/feedback.vue'], resolve)
  },
  {
    name: 'order-summary',
    path: '/order-summary',
    meta: {layout: 'default'},
    component: (resolve) => require(['./pages/order-summary.vue'], resolve)
  },
  {
    name: 'money-summary',
    path: '/money-summary',
    meta: {layout: 'default'},
    component: (resolve) => require(['./pages/money-summary.vue'], resolve)
  },
  {
    name: 'message',
    path: '/message',
    meta: {layout: 'default'},
    component: (resolve) => require(['./pages/message.vue'], resolve)
  },
  {
    name: 'service-package',
    path: '/service-package',
    meta: {layout: 'default'},
    component: (resolve) => require(['./pages/service-package.vue'], resolve)
  },
  {
    name: 'transfer-mgnt',
    path: '/transfer-mgnt',
    meta: {layout: 'default'},
    component: (resolve) => require(['./pages/transfer-mgnt.vue'], resolve)
  },
  {
    name: 'recharge-package',
    path: '/recharge-package',
    meta: {layout: 'default'},
    component: (resolve) => require(['./pages/recharge-package.vue'], resolve)
  },
  {
    name: 'device-summary-data',
    path: '/device-summary-data',
    meta: {layout: 'default'},
    component: (resolve) => require(['./pages/device-summary-data.vue'], resolve)
  }
];
export default routers;



// WEBPACK FOOTER //
// ./src/router.js